module.exports = __webpack_public_path__ + "img/orgunits-icon.4ea24e2a.svg";